export const DOMAIN = 'https://platform.orthosolid.com';
export const DOMAIN_DEV = 'https://dev.platform.orthosolid.com';
export const COMPANY_NAME = 'OrthoSolid';
export const COMPANY_DESCRIPTION = 'OrthoSolid is a platform for 3D printing orthotics';

export const S3_PATIENT_DATA_FOLDER = 'patient-data';
export const S3_PRODUCT_PREVIEW_FOLDER = 'product-preview';
export const S3_TICKETS_FOLDER = 'tickets';
export const S3_TESTING_FOLDER = 'testing';
export const S3_EXPORT_FOLDER = 'exports';
export const S3_PRODUCT_MODELS_FOLDER = 'product-models';
export const S3_COMPANY_LOGO_FOLDER = 'company-logos';
export const S3_THUMBNAIL_FOLDER = 'thumbnails';

// This array IS the /api/images access policy: that route has no auth and redirects
// with `Cache-Control: public`, so a folder added here becomes anonymously readable
// through cacheable URLs. The rest of the bucket is patient data, exports and meshes.
export const S3_PUBLIC_IMAGE_FOLDERS = [S3_COMPANY_LOGO_FOLDER, S3_THUMBNAIL_FOLDER];
export const IMAGE_ROUTE_PREFIX = '/api/images';
export const PLATFORM_MANUAL_ID = 'platform-manual';
export const GENERAL_SETTINGS_ID = 'generalSettings';

export const CUSTOM_FORM_FILE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.pdf'];
export const DATA_FILE_EXTENSIONS = ['.stl', '.obj', '.zip'];
export const TICKET_FILE_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg'];
export const CORS = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  'Access-Control-Max-Age': '86400',
};

export const PSEUDONYMIZED_COOKIE_NAME = 'pseudonymized';

export const PATIENT_DATA_FILE_TYPE = 'file';
export const PATIENT_DATA_DATA_TYPE = 'data';
export const PATIENT_DATA_FORM_TYPE = 'form';

export const SCAN_ORIENTATION_KEY = 'Limb side (Right - Left)';

export const PATIENT_DATA_TYPES = [
  PATIENT_DATA_FILE_TYPE,
  PATIENT_DATA_DATA_TYPE,
  PATIENT_DATA_FORM_TYPE,
];

export const CONFIGURATOR_FORM_TYPE = 'form';
export const CONFIGURATOR_FORM_TYPE_WITH_STEPS = 'form-with-steps';

export const CONFIGURATOR_FORM_TYPES = [CONFIGURATOR_FORM_TYPE, CONFIGURATOR_FORM_TYPE_WITH_STEPS];

export const FIELDS_TO_HIDE = [
  'fullName_',
  'dateOfBirth_',
  'gender_',
  'email_',
  'phone_',
  'patientId_',
  'name_',
];
export const TEXT_TO_HIDE = '••••••••';

export const SHOW_ONLY_MY_PATIENTS_COLUMN = 'showOnlyMyPatients';
export const SHOW_ONLY_MY_ORDERS_COLUMN = 'showOnlyMyOrders';
export const SHOW_ONLY_MY_PRODUCTS_COLUMN = 'showOnlyMyProducts';

export const PATIENT_DATA_ID_NEW = 'new';

export const USER_TO_TRANSFER_ID = 'userToTransferId';

export const HELP_TEXT_STORAGE_KEY = 'activeHelpTextSlug';
export const HELP_TEXT_CHANGE_EVENT = 'helpTextChange';

// Bridges the demo form's created `entry` _id to the configurator's contact form
// (separate routes) so the contact email can include the submitter's details.
export const DEMO_ENTRY_ID_KEY = 'demoEntryId';

export const PRODUCT_WORKFLOW_CATEGORY_CARPI_ID = '373c8259-384b-45b4-b5d7-cbc824b538ab';
export const PRODUCT_WORKFLOW_CATEGORY_MINO_ID = '46278070-7d75-4a6e-a9ca-b11429af5795';
export const PRODUCT_WORKFLOW_CATEGORY_CUSTOM_PRODUCT_ID = '4d1a6c48-ac13-44f6-9088-f10827b0ebc8';
export const PRODUCT_WORKFLOW_CATEGORY_VOLAR_ID = '8893b8a9-820d-42d0-9402-f55fa41401fb';

/** The families whose wizard opens on their favourites page. */
export const FAVOURITES_CATEGORY_IDS: readonly string[] = [
  PRODUCT_WORKFLOW_CATEGORY_CARPI_ID,
  PRODUCT_WORKFLOW_CATEGORY_MINO_ID,
  PRODUCT_WORKFLOW_CATEGORY_VOLAR_ID,
];

export const PRODUCT_WORKFLOW_CARPI_THUMB_ID = 'dfbbcef5-6555-4298-bf82-4ce77020fb83';
export const PRODUCT_WORKFLOW_CARPI_LONG_ID = '0eff7b34-7900-401c-9132-4878a097f467';
export const PRODUCT_WORKFLOW_CARPI_SHORT_ID = '0f0483b8-7de7-476a-aad5-235bf7cbf162';
export const PRODUCT_WORKFLOW_CARPI_TPU_WITH_THUMB_ID = 'a1131546-e3ac-4c4d-b3ff-7759898a9765';
export const PRODUCT_WORKFLOW_CARPI_TPU_WITHOUT_THUMB_ID = '41bde2c9-1d45-4404-992d-608ab2e143ce';
// PRODUCT_WORKFLOW_MINO_{MCP,CMC}_ID already live in the "Mino Workflow" block below.
export const PRODUCT_WORKFLOW_VOLAR_PALM_ID = '1c1b9c21-c9d9-4390-bdb8-966a1d67a1ff';
export const PRODUCT_WORKFLOW_VOLAR_REWORK_ID = '704b19b8-44f3-457c-8a8d-a47e8de17876';

// Product Workflow Steps
export const CARPI_PRODUCT_CONFIGURATION_DEFAULT_ID = '0eccdb2c-4a29-4ff7-967a-722b31b1c5d8';
export const MINO_PRODUCT_CONFIGURATION_DEFAULT_ID = '15819608-40b6-456a-9109-d0baeb198744';
export const VOLAR_PRODUCT_CONFIGURATION_DEFAULT_ID = '74b385b4-7a93-4299-9aa1-e634e11e54c9';
export const WORKFLOW_STEP_STEP_1_ID = 'step-1';
export const WORKFLOW_STEP_STEP_2_ID = 'step-2';
export const WORKFLOW_STEP_STEP_3_ID = 'step-3';
export const WORKFLOW_STEP_STEP_4_ID = 'step-4';
export const WORKFLOW_STEP_STEP_5_ID = 'step-5';

// Production Location
export const WORKFLOW_STEP_PRODUCTION_LOCATION_CARPI_ID = '637a2941-c7e3-4cb8-82b7-a111b1ba82c6';
export const WORKFLOW_STEP_PRODUCTION_LOCATION_MINO_ID = 'bdc1c9bc-46f4-4571-b7ea-a1422d265078';
export const WORKFLOW_STEP_PRODUCTION_LOCATION_VOLAR_ID = 'a1803380-4aa5-4373-abb8-c7824b4f99e9';

// Material
export const WORKFLOW_STEP_MATERIAL_CARPI_ID = 'dd655b66-b70a-4acb-98f9-2f39c3635207';
export const WORKFLOW_STEP_MATERIAL_MINO_ID = '25bf05af-864a-4b3d-ad50-5792af3c8d9e';

// Thumb Support
export const WORKFLOW_STEP_THUMB_SUPPORT_CARPI_ID = '62adae2f-5f0d-49dd-b007-509aba4b9703';
export const WORKFLOW_STEP_THUMB_SUPPORT_MINO_ID = '4f3e30a9-497b-4be1-bf79-e1dce0df4d86';
export const WORKFLOW_STEP_THUMB_SUPPORT_VOLAR_ID = '7de361c1-611e-4445-b0c4-5e9810cf2d05';
export const THUMB_SUPPORT_VALUE_ID = 'thumbSupport';

// Carpi
export const WORKFLOW_STEP_BRACE_LENGTH_ID = 'ab371b93-2300-4a30-b69b-ea2a969195c4';
export const BRACE_LENGTH_VALUE_ID = 'braceLength';
export const WORKFLOW_STEP_OPENING_POSITION_ID = '8f676765-8e58-4f47-bbb7-608ee54fd42b';
export const OPENING_LOCATION_VALUE_ID = 'openingLocation';

// Volar
export const HINGES_VALUE_ID = 'hinges';
export const HINGED_OPTION_VALUE_ID = 'hingedOption';
export const PADDING_VALUE_ID = 'padding';
export const EXTRA_PADDING_VALUE_ID = 'extraPadding';
export const STRAPS_VALUE_ID = 'straps';
export const WORKFLOW_STEP_HINGES_ID = '3efcbeae-d385-4a47-85b5-5043cf45dd62';
export const WORKFLOW_STEP_PADDING_ID = '4ae9af73-5b5d-4ac4-b690-d97600bc8fda';
export const WORKFLOW_STEP_STRAPS_ID = '482eb139-ec32-4bee-a9ed-ac83dbcf09dd';
export const WORKFLOW_STEP_OUTCOME_ID = 'outcome';

// Carpi Product Configurations
export const CARPI_PRODUCT_CONFIGURATION_CARPI_SHORT_ID = '04d21d82-c0dc-4a0d-9c8b-5f7b29faa8d7';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_SHORT_POWDERBED_ID =
  '88f8a11e-bccd-4474-be11-0b2e2ad44dff';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_LONG_ID = 'a1cfabe5-f0d1-4c45-914a-90786c42327b';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_LONG_POWDERBED_ID =
  '40917462-2100-4b00-9f62-cdf7471eca72';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_THUMB_SHORT_ID =
  'b92061d4-4ddc-4779-aa35-16fa7ef6c428';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_THUMB_SHORT_POWDERBED_ID =
  '35c4a41c-136b-46f5-8880-4a59d7cb52c2';

// Carpi Outcomes
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_1_ID =
  '9fcaa2b8-9ad4-4567-8197-be892160c238';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_2_ID =
  '40c20e3e-cf72-490a-976c-efe22bb7b659';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_3_ID =
  'd34e94cc-977f-4a30-b81c-e598a06f919d';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_4_ID =
  '72179e17-0817-49f8-ba0f-136e29607f44';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_5_ID =
  '660e8e53-9b25-4e62-b77a-297f9a5a21b9';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_6_ID =
  '173e5134-4d58-498f-8fe0-320643c59291';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_7_ID =
  '1129d8de-d8ef-4408-9eae-92773fb0c823';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_8_ID =
  '9e1b2381-60d0-4317-9a0a-e9e8a76b17ab';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_9_ID =
  'd89465da-3e90-442a-9b0c-64139488ab67';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_10_ID =
  'e615e3b8-a7bc-4343-b2c5-2ce14d85de63';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_11_ID =
  '5b9400d7-004f-47ef-a4b3-07af6ee76b83';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_12_ID =
  '74fc2d57-60d6-4fb3-823a-0a27cebd9e6a';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_13_ID =
  '597ad3c8-48ff-4e05-8eea-a08d97355cfa';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_14_ID =
  'b4332ab6-6bb8-4cf3-a6dc-b1fc8c9707df';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_15_ID =
  'fedb0a02-49d4-4f59-a058-ce22c4fb360f';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_16_ID =
  '78308e14-f8e5-478b-8dd6-5f34cc49a28f';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_17_ID =
  '0008d1c9-cf54-477d-b64a-2716853676d2';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_18_ID =
  '1a2ae4ee-a308-440b-a952-577f9967c927';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_19_ID =
  '224df6ce-31ec-4418-8554-47640d5bcbd6';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_20_ID =
  '3ade66b2-968a-4f5f-bc55-c5cde6f9a9ea';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_21_ID =
  'ebb2e687-d4dd-4c2e-ae54-01a93ca2e515';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_22_ID =
  '0460bc32-217e-4478-bc00-1584855ee63d';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_23_ID =
  '52074299-c5b5-4d1d-be55-c421c7e9de83';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_24_ID =
  '21220238-30a0-4feb-961b-c5085d7ce341';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_25_ID =
  '046d853f-f9c2-4990-988d-b47b99a71329';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_26_ID =
  '805efda3-261c-4353-ad3f-24a33e664c92';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_27_ID =
  '04f12e56-709d-4410-be17-ce6011ee0422';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_28_ID =
  '228a2f18-4537-4669-b229-f6d65601e37b';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_29_ID =
  'e37addc6-5274-464a-a842-66d10a9e2c2d';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_30_ID =
  '3766c119-5413-494c-847a-6b0345052fe3';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_31_ID =
  '14b2a954-4d6f-4897-bc71-0a82068d9732';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_32_ID =
  '423498ae-5e6f-4f85-bd50-13a9800aebcb';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_33_ID =
  '4d4723ec-dee7-4ab9-b97f-5dd9a8516673';
export const CARPI_PRODUCT_CONFIGURATION_CARPI_TPU_OUTCOME_34_ID =
  'da5cce56-7b39-4fc1-897b-28e43bfbd7a0';

// Mino Workflow
export const PRODUCT_WORKFLOW_MINO_MCP_ID = '6b1e0224-4216-4227-b053-0f32940b375e';
export const PRODUCT_WORKFLOW_MINO_CMC_ID = 'ba49b398-6ae1-4e4e-a1f7-0f3bd7fe3cb7';

// Mino Outcomes
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_1_ID =
  'b37a7780-4855-4acc-8b26-76f7c18ff341';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_2_ID =
  'a3c4a70f-9902-4bde-82c3-5f8b04a9d3f8';
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_3_ID =
  'c61f5f36-f6f6-4a44-8465-46d4ec58d830';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_4_ID =
  'e2aacad2-6b27-4c40-9a69-024e324066b0';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_5_ID =
  'e0fc0413-a175-4917-9fcc-92e3be31d3c8';
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_6_ID =
  '94993051-7ff1-4e0b-ad4d-129adba2dc13';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_7_ID =
  'f56ff272-2ecf-49ad-8076-2a73679acf18';
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_8_ID =
  '37d3c269-d5aa-46f4-9935-339c5b218999';
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_9_ID =
  '267139f8-8cbe-4f3a-a1b1-2b22bd0ab2f0';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_10_ID =
  'b7443975-6be3-475a-bb78-7f315aa702fe';
export const MINO_PRODUCT_CONFIGURATION_MINO_CMC_OUTCOME_11_ID =
  'c79abaff-5e04-43a8-b1d2-ffe835fad2e4';
export const MINO_PRODUCT_CONFIGURATION_MINO_MCP_OUTCOME_12_ID =
  '08157682-0a3c-4561-a1fd-0a25e399cc55';

// Volar Workflow
export const PRODUCT_WORKFLOW_VOLAR_THUMB_ID = 'd1738163-a733-4414-b9a5-cb56146555ab';

// Volar Outcomes
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_1_ID =
  '39f62363-1894-4729-bc67-568de411ca31';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_2_ID =
  'cd9d3d26-bfa0-47d8-a1d6-3a24d5cd5798';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_3_ID =
  '0825460d-a42b-419d-bd81-8cdeeac67434';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_4_ID =
  '59a48b83-4958-4b0a-a8cf-b18205834140';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_5_ID =
  '477527fc-591e-4f7c-bc86-ae46a0752118';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_6_ID =
  'c5872049-7c5d-47fb-9eef-cdf24ca82b34';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_7_ID =
  'cf7ad13e-ed80-458a-852c-52fe4307038a';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_8_ID =
  'fa6f394f-aa4c-493d-aee2-985e92e1cb57';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_9_ID =
  '3f1e54c2-de50-4561-9b83-ff2d5d86004e';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_10_ID =
  'f9f9f724-e36a-4d5a-8c70-7fbf5580169e';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_11_ID =
  '39338866-e326-423e-9061-6e37cec5c350';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_12_ID =
  '52cb9bd9-1de2-4ebd-879e-1e7f0d309ee5';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_13_ID =
  '0a527160-0e6c-42bc-b877-a75905bd8c73';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_14_ID =
  '61e0e798-c789-4e6e-a4a0-6cebbdb0f0db';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_15_ID =
  'e8fb3879-433f-487a-83a1-a34763bb49b7';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_16_ID =
  'a2980567-4c70-48da-8e8c-83c8dcce8200';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_17_ID =
  '20758362-fee3-4819-a2df-fff85e5512a7';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_18_ID =
  'ed251579-8990-4c39-a0cb-29bcb865e249';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_19_ID =
  '6bfdfec0-76c0-4849-8ca9-60304214b387';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_20_ID =
  '86d774ad-40e4-47ed-887c-2e203de7fea4';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_21_ID =
  '2da7ab36-c3b5-44ed-a589-33ce4e25c7f9';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_22_ID =
  'b9b8645e-33d4-4b6d-8b4e-c320758eb6ce';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_23_ID =
  '7a340440-a195-462e-b45c-6b5134a1e8eb';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_24_ID =
  '8043d7c5-dc9b-47b7-83eb-d00196ce1940';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_25_ID =
  '9d8782c2-178a-4f90-8c5c-c24a7e2e2b9e';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_26_ID =
  '6fa26dc9-16ba-4fc6-adae-ac4aaf4153cd';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_27_ID =
  '90433f59-4add-4127-8357-9802b2ec4d31';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_28_ID =
  '1d711a73-286e-475b-9233-1565b64928e6';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_29_ID =
  '14bfeea0-1483-4cd5-af99-d08da443e220';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_30_ID =
  '31f9a2d1-6238-4e23-9a3d-649d5cdf606f';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_31_ID =
  'e84f344c-7b8f-41c8-a422-e9441d3ef643';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_32_ID =
  'babad008-6c68-4f86-bb18-2535eb306dc9';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_33_ID =
  '93f0023e-c6f3-40cc-b033-4fcb49fc818b';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_34_ID =
  'd60d8b6b-835a-42d7-a5d8-78d7a4350f32';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_35_ID =
  '54239a4e-0a8d-4324-a03f-4efe41e40b8c';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_36_ID =
  'ae5d3024-8a5b-48c6-816e-294ad32c55f6';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_37_ID =
  'a04e33b5-3a45-4a53-9da2-caddea176561';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_38_ID =
  'db87c34f-abb0-4e16-ad02-76befe03def3';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_39_ID =
  '1274f4e2-f5e1-47a3-a5d0-7f076e1629d3';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_40_ID =
  'df9072a3-17df-46f2-af45-9d89f1604855';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_41_ID =
  '5fd879f2-f3e3-4eee-bf8e-18cbfb92684e';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_42_ID =
  '90ec1548-d318-44f4-bcdc-62adc9660252';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_43_ID =
  '0b5e2560-4246-47be-93fc-63e04ec8cfeb';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_44_ID =
  'eb672896-ce1b-4031-84d6-8d7e2c7cfcb3';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_45_ID =
  'b79ec7be-15e6-40cc-a464-f584adf6e3a7';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_46_ID =
  'efdafc29-7601-4938-b45c-fb2aeba108a6';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_47_ID =
  '9343b7d1-9c56-4100-bca6-e1dce1d1da2f';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_48_ID =
  '665fe78b-81fa-4dd8-9eed-7f6956708755';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_49_ID =
  'f2bceb7f-ccb7-4dd6-b57c-8dc7600f1d80';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_50_ID =
  '00dd7f5a-5d08-40ff-975a-1ac76f34af97';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_51_ID =
  'd74dcc15-85b8-4055-ae0a-935cf4643782';
export const VOLAR_PRODUCT_CONFIGURATION_VOLAR_OUTCOME_52_ID =
  '1612f3ee-fdf6-4dbd-9db8-058ed6dbcc15';

// Product Workflow
// Production Location
export const WORKFLOW_PRODUCED_BY_ORTHOBROKER_ID = '1ab6c12e-5d6a-4a1c-a9d5-dd019a6af660';
export const WORKFLOW_PRODUCED_BY_ORTHOBROKER_MINO_ID = '4c65ec07-61c2-4a6e-a695-51e967f1251b';
export const WORKFLOW_PRODUCED_BY_ORTHOBROKER_VOLAR_ID = '80d87bad-b61b-4c0c-bf35-2753b036e6af';
export const WORKFLOW_PRODUCED_YOURSELF_FDM_ID = 'a57806e8-d0db-4f99-9423-1e74058ee25f';
export const WORKFLOW_PRODUCED_YOURSELF_FDM_MINO_ID = '38b68f38-cc6d-45a5-ae29-76a7f33ff7c7';
export const WORKFLOW_PRODUCED_YOURSELF_FDM_VOLAR_ID = '90e2ad4d-3418-449f-8e83-4acf57908f3e';
export const WORKFLOW_PRODUCED_YOURSELF_POWDERBED_ID = '89b7424c-b7ee-4975-baba-1ad8c7909c9c';
export const WORKFLOW_PRODUCED_YOURSELF_POWDERBED_MINO_ID = 'b23e02d2-060f-405f-ad0f-08903c40e9bd';
export const WORKFLOW_PRODUCED_YOURSELF_POWDERBED_VOLAR_ID = '00af8a60-f648-42bf-88bb-6cca110515fd';

// Material
export const WORKFLOW_PA11_ID = '6cdef014-2574-4d6e-9228-5d72a5e7e02e';
export const WORKFLOW_PA11_MINO_ID = '79e8804a-d907-41cd-837d-3bd3ea3c05f9';
export const WORKFLOW_PA11_TITLE = 'PA11';
export const WORKFLOW_TPU_ID = '75a810be-9092-4b37-b2d2-beb1b3dec8a3';
export const WORKFLOW_TPU_MINO_ID = '34a03260-4ff9-4211-884c-878006456061';
export const WORKFLOW_TPU_TITLE = 'TPU';
export const WORKFLOW_SHAP3D_ID = 'b1998e1a-d384-49ab-8190-749085ddc9f8';
export const WORKFLOW_SHAP3D_MINO_ID = '607c1a3b-e4c6-4eaf-934c-6e33f518274d';
export const WORKFLOW_FDM_TITLE = 'FDM';
export const WORKFLOW_SHAP3D_TITLE = 'SHAP3D';
export const WORKFLOW_OTHER_FILAMENT_ID = 'cafa719f-b2d8-4bf5-be43-a0b715276e4b';
export const WORKFLOW_OTHER_FILAMENT_MINO_ID = 'c282c81a-5b0b-4dfe-a539-1ef784321342';

// Thumb Support
export const WORKFLOW_FREE_THUMB_ID = '5540c1f8-8cd9-444d-a02d-5b94cea9ca55';
export const WORKFLOW_FREE_THUMB_MINO_ID = '0ba8237a-77c5-4271-8e76-580bec90622d';
export const WORKFLOW_FREE_THUMB_VOLAR_ID = '620b1661-99f2-4631-a84b-f6b4b5b4ffb5';
export const WORKFLOW_THUMB_SUPPORTED_ID = '5d1cd1c2-5179-48fe-b593-697531514467';
export const WORKFLOW_THUMB_SUPPORTED_MINO_ID = '553c47e9-5392-4f0b-b8ed-74bf4a7259fc';
export const WORKFLOW_THUMB_SUPPORTED_VOLAR_ID = '2d0fade9-b57a-43a6-8a76-561ac8c93697';
export const WORKFLOW_THUMB_DIAMETER_ID = '8951887b-d0cd-40a6-a256-fb49e918dfa8';
export const WORKFLOW_THUMB_DIAMETER_MINO_ID = '3ba430a8-d029-41af-83f7-0a358074f34a';
// Fallback bounds used when neither the product template's thumb-diameter input parameter
// nor the thumb-diameter answer sets them in Sanity (see getThumbDiameterConfig).
export const WORKFLOW_THUMB_DIAMETER_MIN = 17;
export const WORKFLOW_THUMB_DIAMETER_MAX = 27;
export const WORKFLOW_THUMB_DIAMETER_STEP = 1;
// Slug that ties the thumb-diameter workflow input to its Sanity config entry and
// its NumberedInput. Keep in sync with the NumberedInput slug in useThumbDiameterDialog.
export const THUMB_DIAMETER_SLUG = 'thumb-diameter';

// Brace Length
export const WORKFLOW_SHORT_ID = '1d06bdef-068d-434f-b0ef-e3ef02d38079';
export const WORKFLOW_LONG_ID = '794aae1f-5344-420e-9b88-85738fb43953';
export const WORKFLOW_SHORT_TITLE = 'Short orthosis';

// Opening Location
export const WORKFLOW_ULNAR_OPENING_ID = '43204442-6615-4b11-b5fe-135b12e5cabd';
export const WORKFLOW_ULNAR_OPENING_TITLE = 'Ulnar opening';
export const WORKFLOW_DORSAL_OPENING_ID = 'b1813862-6861-426e-8f3b-120bed9bf1a1';

// Hinges
export const WORKFLOW_STATIC_ID = '24cc415d-8892-4703-bdb8-867f9c08b079';
export const WORKFLOW_HINGED_ID = 'abdf5a7f-22dc-4419-a793-0de712eb1cc3';
export const WORKFLOW_HINGED_OPTION_ID = '621f5ae9-2d6e-4c64-80e9-d690b0604d40';

// Hinged Option
export const HINGED_OPTION_BASKO_MULTIMOTION_ID = '69d73236-ac75-4bb2-b099-c8670c6d0d93';
export const HINGED_OPTION_CAROLI_DYNA_ID = '995180e2-3633-4a88-bdc8-866bb9cd38de';
export const HINGED_OPTION_CAROLI_MONO_ID = 'a8b709ca-7363-442e-bff9-e00510712bff';
export const HINGED_OPTION_ALBRECHT_ID = '4f3b9782-19d0-42b2-970f-f88b20bd5851';
export const HINGED_OPTION_ULTRAFLEX_ID = '3ba927cc-8c33-4547-8b60-a89852740537';

// Padding
export const PRODUCT_WORKFLOW_NO_PADDING_ID = '9dbf929e-a7b1-44c7-9f6a-2eba7a6bada6';
export const PRODUCT_WORKFLOW_PADDING_BY_OTB_ID = '8b496726-fc47-4be7-b6ba-01b572bf3746';
export const PRODUCT_WORKFLOW_OWN_PADDING_ID = 'e6618388-7f8e-41b8-931c-b7c3eebbfee8';

// Straps
export const WORKFLOW_NO_STRAPS_ID = '3a5be780-0550-49b9-bb65-870dce07519d';
export const WORKFLOW_STRAPSET_SEPARATE_ID = '6cda16d3-20aa-486d-b257-020967e5fe60';
export const WORKFLOW_STRAPS_ATTACHED_ID = 'd2118773-b5ac-45f8-b1ff-019ca4813e19';
export const WORKFLOW_EXTRA_PADDING_ID = 'cc174f23-82d7-47ff-a0d9-73b1bb101e7c';
export const WORKFLOW_PADDING_THICKNESS_ID = '2975aead-7739-4583-9c3d-b40fbc74c4e0';

// Relevant emails
export const DEV_EMAIL = 'development@orthobroker.com';
export const PETER_EMAIL = 'p.vandenBerg@orthobroker.com';
export const PNO_EMAIL = 'philip@pn-o.be';
export const ROMANE_EMAIL = 'r.rouffart@orthobroker.com';
export const PATRICK_EMAIL = 'patrick.garmyn@orthobroker.com';
export const LUKAS_EMAIL = 'l.bridts@orthobroker.com';
export const REPLY_TO = `OrthoSolid Support <${DEV_EMAIL}>`;

export const NAME_SLUG = 'name';

// Specifications / Parameters
export const DISTANCE_BUCKLE_TO_ULNA_SPECIFICATION = 'Distance buckle to ulna';
export const LENGTH_BELOW_ULNA_SPECIFICATION = 'Length below ulna';
export const BRACE_THICKNESS_PARAMETER = 'Brace thickness';
export const ORTHOSIS_THICKNESS_OUTPUT = 'Orthosis thickness';
export const BRACE_THICKNESS_SPECIFICATION = 'Brace thickness';
export const DISTAL_OPENING_WIDTH_OUTPUT = 'Distal opening width';
export const PROXIMAL_OPENING_WIDTH_OUTPUT = 'Proximal opening width';
export const HEIGHT_IP_BRIDGE_FROM_MCP_OUTPUT = 'Height IP bridge (from MCP)';
export const THUMB_SUPPORT_LENGTH_FROM_MCP_OUTPUT = 'Thumb support length (from MCP)';
export const TOGGLE_MCP_HOLE_PARAMETER = 'Toggle MCP hole';
export const WIDTH_MCP_HOLE_PARAMETER = 'Width MCP hole';
export const HEIGHT_MCP_HOLE_PARAMETER = 'Height MCP hole';
export const EDGE_PIPING_SPECIFICATION = 'Edge piping';
export const THUMB_WEB_FOLDING_EDGE_SPECIFICATION = 'Thumb web folding edge';
export const CLOSING_WIDTH_PARAMETER = 'Closing width';
export const STRAP_WIDTH_PARAMETER = 'Strap width';
export const MATERIAL_SPECIFICATION = 'Material';
export const SCAN_URL_SPECIFICATION = 'Default';
export const SWITCH_BUCKLE_POSITION_PARAMETER = 'Switch buckle position';
export const BUCKLE_TYPE_PARAMETER = 'Buckle type';
export const VENTILATION_HOLES_PARAMETER = 'Ventilation holes';
export const THUMB_DIAMETER_PARAMETER = 'Thumb diameter';
export const HINGED_OPTION_PARAMETER = 'Hinged Option';
export const DISTAL_OPENING_POSITION_PARAMETER = 'Distal opening position';
export const PROXIMAL_OPENING_POSITION_PARAMETER = 'Proximal opening position';
export const OPENING_POSITION_PARAMETER = 'Opening position';
export const EXTRA_LINING_PARAMETER = 'Extra lining';
export const TRANSVERSAL_PALM_ARCH_INTENSITY_PARAMETER = 'Transversal palm arch intensity';
export const PRODUCT_FINISHING_PARAMETER = 'Product finishing';

// Outputs
export const CALCULATED_BRACE_THICKNESS_OUTPUT = 'calculated-Brace thickness';

// Sessions
export const FAST_SESSION = 'fast-session';
export const FULL_SESSION = 'full-session';

// Pagination Sorting
export const DEFAULT_SORT = 'created desc';

// Tests
export const DEFAULT_TEST_PATIENT_ID = 'bT42lYuIExhht8Ui5uzu28';
export const TEST_PATIENT_ID = 'Z5tyIhOWsR99a1RypJso8j';
export const TEST_PATIENT_NAME = 'Ben Maartens';
export const CARPI_ID = '0000dfhn';
export const MINO_ID = '0000Jt32';
export const VOLAR_ID = '00007UBP';

// Company creation
export const COMPANY_CLIENT_ID_VALID_PATTERN = /^[a-zA-Z0-9._-]+$/;
export const MASTER_COMPANY_ID = 'company-orthobroker';
export const TEST_COMPANY_ID = 'i2H1dL6G';
